// import Vue from 'vue'

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
    return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js